const BUSINESS_IDENTIFICATION_TYPE_OPTIONS = [
    { label: "Employer Identification Number (EIN)", value: "Employer Identification Number (EIN)" },
    { label: "Trust Identification Number (TIN)", value: "Trust Identification Number (TIN)" },
    { label: "Sole proprietor's SSN", value: "Sole proprietor's SSN" },
];

export default BUSINESS_IDENTIFICATION_TYPE_OPTIONS;